export default __webpack_public_path__ + "static/media/icon_materiais.9d0ed2a8.svg";